"use client";

import { c as _c } from "react-compiler-runtime";
import { AnimatePresence, motion } from "motion/react";
type CaptureFlashOverlayProps = {
  showFlash: boolean;
  showRetinaFlash?: boolean;
};
export function CaptureFlashOverlay(t0) {
  const $ = _c(11);
  const {
    showFlash,
    showRetinaFlash: t1
  } = t0;
  const showRetinaFlash = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== showRetinaFlash) {
    t2 = showRetinaFlash && <motion.div animate={{
      opacity: 1
    }} className="pointer-events-none fixed inset-0 z-100" exit={{
      opacity: 0,
      transition: {
        duration: 0.2
      }
    }} initial={{
      opacity: 0
    }} style={{
      background: "#FFFFFF"
    }} transition={{
      duration: 0.08
    }}><div className="absolute inset-0" style={{
        background: "radial-gradient(ellipse 120% 100% at 50% 40%, #FFFFFF 0%, #FFFCF8 60%, #FFF8F0 100%)"
      }} /></motion.div>;
    $[0] = showRetinaFlash;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <AnimatePresence>{t2}</AnimatePresence>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== showFlash) {
    t4 = showFlash && <motion.div animate={{
      opacity: [0, 1, 1, 0.9, 0.6, 0]
    }} className="pointer-events-none fixed inset-0 z-99" initial={{
      opacity: 0
    }} style={{
      background: "#FFFFFF"
    }} transition={{
      duration: 1.2,
      times: [0, 0.04, 0.3, 0.5, 0.8, 1]
    }}><div className="absolute inset-0" style={{
        background: "radial-gradient(ellipse 120% 100% at 50% 40%, #FFFFFF 0%, #FFFCF8 60%, #FFF8F0 100%)"
      }} /></motion.div>;
    $[4] = showFlash;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <AnimatePresence>{t4}</AnimatePresence>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}